export const appTypes = {
  SET_VIDEO: 'SET_VIDEO',
  SET_USER_COORDS: "SET_USER_COORDS",
  SET_PLAY_INTRO: "SET_PLAY_INTRO",
  SET_HOVER_VIDEO: "SET_HOVER_VIDEO"
};